import { getHttpClient } from '@vnetwork/datacentral-core/http'

// The app's axios instance, from core's registry (the host registers it in
// src/utils/axios/register-core.ts). Resolved per call, never at import: core
// throws for a client that is not registered yet, and an import-time lookup
// would make the module's load order matter.
export const datacentral = () => getHttpClient('datacentral')
